import * as Utils from './Utils';
import { ParameterTypes } from './Enums';

export var ParameterValidators = function() {
    var validators = {};

    function validateParameter(parameter, value, validatorFunc, compareFunc) {
        var values = []
            .concat(value)
            .map(function(value1) {
                return checkAvailableValues(parameter, validatorFunc(value1), compareFunc);
            });

        if (parameter.multivalue) {
            if (value == null || value.length == 0) {
                if (parameter.allowNull) {
                    return value;
                }

                throw 'Please input a valid value.';

            }

            return values;
        }

        return values[0];
    }

    function isNull(parameter, value) {
        return parameter.allowNull && [null, '', undefined].indexOf(value) != -1;
    }

    function checkAvailableValues(parameter, value, compareFunc) {
        if (parameter.availableValues) {
            var found = false;
            Utils.each(parameter.availableValues, function(i, av) {
                found = compareFunc(value, av.value);
                return !found;
            });

            if (!found) {
                if (parameter.allowNull && !value) {
                    return value;
                }
                throw 'Please input a valid value.';
            }
        }

        return value;
    }

    validators[ParameterTypes.STRING] = {
        validate: function(parameter, value) {
            return validateParameter(
                parameter,
                value,
                function(value) {
                    if (!value) {
                        if (parameter.allowNull) {
                            return null;
                        }

                        if (parameter.allowBlank) {
                            return '';
                        }
                        throw 'Parameter value cannot be empty.';
                    }
                    return value;
                },
                function(s1, s2) {
                    return s1 == s2;
                }
            );
        }
    };

    validators[ParameterTypes.FLOAT] = {
        validate: function(parameter, value) {
            return validateParameter(
                parameter,
                value,
                function(value) {
                    var num = Utils.tryParseFloat(value);
                    if (isNaN(num)) {
                        if (isNull(parameter, value)) {
                            return null;
                        }
                        throw 'Parameter value cannot be empty.';
                    }
                    return num;
                },
                function(f1, f2) {
                    return Utils.tryParseFloat(f1) == Utils.tryParseFloat(f2);
                }
            );
        }
    };

    validators[ParameterTypes.INTEGER] = {
        validate: function(parameter, value) {
            return validateParameter(
                parameter,
                value,
                function(value) {
                    var num = Utils.tryParseInt(value);
                    if (isNaN(num)) {
                        if (isNull(parameter, value)) {
                            return null;
                        }
                        throw 'Parameter value cannot be empty.';
                    }
                    return num;
                },
                function(n1, n2) {
                    return Utils.tryParseInt(n1) == Utils.tryParseFloat(n2);
                }
            );
        }
    };

    validators[ParameterTypes.DATETIME] = {
        validate: function(parameter, value) {
            return validateParameter(
                parameter,
                value,
                function(value) {
                    if (parameter.allowNull && (value === null || value === '' || value === undefined)) {
                        return null;
                    }
                    if (!isNaN(Date.parse(value))) {
                        if (parameter.availableValues) {
                            return value;
                        }

                        return Utils.parseToLocalDate(value);
                    }
                    throw 'Please input a valid date.';
                },
                function(d1, d2) {
                    // eslint-disable-next-line no-param-reassign
                    d1 = Utils.parseToLocalDate(d1);
                    // eslint-disable-next-line no-param-reassign
                    d2 = Utils.parseToLocalDate(d2);
                    return d1.getTime() == d2.getTime();
                });
        }
    };

    validators[ParameterTypes.BOOLEAN] = {
        validate: function(parameter, value) {
            return validateParameter(
                parameter,
                value,
                function(value) {
                    if (['true', 'false'].indexOf((String(value)).toLowerCase()) != -1) {
                        return Boolean(value);
                    }
                    if (isNull(parameter, value)) {
                        return null;
                    }
                    throw 'Parameter value cannot be empty.';
                },
                function(b1, b2) {
                    return Boolean(b1) == Boolean(b2);
                });
        }
    };

    return {
        validate: function(parameter, value) {
            var v = validators[parameter.type];
            if (!v) {
                throw Utils.stringFormat('Cannot validate parameter of type {type}.', parameter);
            }
            return v.validate(parameter, value);
        }
    };
}();
